import React from "react";
import "../styles/ProfileCard.css";

const ProfileCard = () => {
  return (
    <div className="profile-card">
      <div className="profile-wrap">
        <div className="profile-image-wrapper">
          <img src="/ceo.jpg" alt="CEO" className="profile-image" />
        </div>
        <div className="ceo-details">
          <h2>Benjamin Ekow Asem-Mensah</h2>
          <strong>Co-Founder & CEO, NexaGrowth Africa</strong>
        </div>
      </div>
      <div className="profile-info">
        <p className="Welcome-description">
          Africa stands at the brink of a new dawn a continent no longer defined
          by limitations, but by limitless potential. The outdated narrative of
          a fragile, dependent Africa is steadily being replaced by a compelling
          truth: Africa is resourceful, resilient, and rising.
        </p>
        <p className="Welcome-description">
          At the heart of this transformation is a bold, ambitious generation of
          young innovators, entrepreneurs, and changemakers determined not only
          to rewrite the story of the continent but to lead it. With the right
          tools, strategies, and platforms, these visionaries have the power to
          spark unprecedented growth and create lasting impact.
        </p>
        <p className="Welcome-description">
          NexaGrowth Africa was founded on this very belief that when we empower
          our youth, support our SMEs, and nurture innovation, we build a future
          that is self-sustaining, inclusive, and globally competitive. From
          capacity building and strategy consulting to innovation programs and
          startup acceleration, our work is rooted in a deep commitment to
          Africa’s long-term prosperity.
        </p>
        <p className="Welcome-description">
          We are more than consultants we are co-creators of a future where
          African solutions lead global conversations.
        </p>
        <p className="Welcome-description">
          Here’s to a thriving Africa powered by its people, led by its youth,
          and built by bold ideas. Welcome to NexaGrowth Africa.
        </p>
      </div>
    </div>
  );
};

export default ProfileCard;
